import moment from 'moment';

class Auth {

    startSession(p_rol, p_project) {
        console.log('# auth: startSession.--'+p_rol+'---------------')
        localStorage.setItem('auniaweb_auth_rol', p_rol);
        localStorage.setItem('auniaweb_auth_project', p_project);
        localStorage.setItem('auniaweb_auth_expires_at', moment().add(1,'d').valueOf());
    }

    endSession() {
        console.log('# auth:endSession.--------------------');
        // localStorage.removeItem('auniaweb_auth_access_token');
        localStorage.removeItem('auniaweb_auth_expires_at');
    }
    isAuthenticated() {
        const expiresAt = localStorage.getItem('auniaweb_auth_expires_at');
        if (expiresAt && moment().valueOf() < expiresAt) {
            // console.log('# auth: ok, session valid. ' + moment().valueOf() +' < ' + expiresAt);
            return true;
        } else {
            // console.log('# auth: ko, session invalid. ' + moment().valueOf() +' < ' + expiresAt);
            return false;
        }
    }
    getRol(){
        return localStorage.getItem('auniaweb_auth_rol')
    }
    isClw() {
        return this.getRol() === 'clw';
    }
    isCbm() {
        return this.getRol() === 'cbm';
    }
}

export default Auth


// WEBPACK FOOTER //
// ./src/services/Auth.js